import { render, staticRenderFns } from "./1.CheckInfo.vue?vue&type=template&id=87137ccc&scoped=true&"
import script from "./1.CheckInfo.vue?vue&type=script&lang=js&"
export * from "./1.CheckInfo.vue?vue&type=script&lang=js&"
import style0 from "./1.CheckInfo.vue?vue&type=style&index=0&id=87137ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87137ccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87137ccc')) {
      api.createRecord('87137ccc', component.options)
    } else {
      api.reload('87137ccc', component.options)
    }
    module.hot.accept("./1.CheckInfo.vue?vue&type=template&id=87137ccc&scoped=true&", function () {
      api.rerender('87137ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/訂單流程/1.CheckInfo.vue"
export default component.exports